import { currency } from "../../constants/common";

export const PAYPAL_CASHOUT_TOKEN = currency.SIKI;

export function buildPaypalCashoutPayload({
  amount,
  accountEmail,
  paypalAddress,
}) {
  return {
    amount,
    email: accountEmail,
    token: PAYPAL_CASHOUT_TOKEN,
    address: paypalAddress,
    memo: "",
  };
}
